import { createContext } from 'react';
import { AgreementField } from 'models/Agreement';

type AgreementFieldsPreviewContextProps = {
  fields: AgreementField[];
};

export default createContext<AgreementFieldsPreviewContextProps>({
  fields: [],
});
